module.exports = __webpack_public_path__ + "media/images/flags/4x3/stp-02a19c7f4850f0aa24987867a1f08b7e.svg";